/*
File Name: index.js
Created Date: 2020-05-26 09:47:08
Author: yeyong
Last modified: 2020-06-10 11:50:30
*/
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Index from '@/views/index'
import Login from '@/views/login'
import Message from '@/views/Message'

// const lazy = (path) => {
//   return () => import(`@/views/${path}`)
// }
// const load = (path) => {
//   return () => import(`@/components/${path}`)
// }

const createRouter = [
  { path: "/", name: "index", component: Index },
  { path: "/message", name: "message", component: Message },
  { path: "/question", name: "question", component: () => import(/* webpackChunkName: "question" */ `@/views/Question`) },
  { path: "/login", name: "login", component: Login },
  {
    path: "/group", name: "group", component: () => import('@/views/Layout'), children: [
      { path: 'new', name: 'groupNew', component: () => import('@/views/GroupNew') },
      { path: ':id/set', name: 'groupSet', props: true, component: () => import('@/views/GroupSet') },
      { path: ':id', name: 'groupChat', component: () => import('@/views/GroupChat'), props: true },
    ]
  },
  { path: "*", name: "index", component: Index },

]


const r = () => new Router({
  mode: 'history',
  routes: createRouter
})

const router = r()

export default router
